import { render, staticRenderFns } from "./AboutDevelopment.vue?vue&type=template&id=443b747c&scoped=true&"
import script from "./AboutDevelopment.vue?vue&type=script&lang=js&"
export * from "./AboutDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./AboutDevelopment.vue?vue&type=style&index=0&id=443b747c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b747c",
  null
  
)

export default component.exports